import { uniqBy } from "lodash-es";

import Email from "@mapmycustomers/shared/types/email/Email";

const getAllEmailRecipients = (email: Email, uniq: boolean = true) => {
  const allEmailRecipients = [...email.recipientAddress, ...(email.cc || []), ...(email.bcc || [])];

  if (!uniq) {
    return allEmailRecipients;
  }

  return uniqBy(allEmailRecipients, (emailRecipient) => emailRecipient.email);
};

export default getAllEmailRecipients;
